module.exports = __webpack_public_path__ + "img/invitation_iamge_more_en@2x.6a0b3c51.png";